/* eslint-disable */
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import Footer from '../../Components/Footer/Footer.component';
import I18n from '../../Components/I18n/I18n.component';
import Page from '../../Components/Page/Page.component';
import withEntries from '../../Contexts/Entries/WithEntries.context';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import { createHomePageLink } from '../Home/Home.page.route';
import './Error.page.i18n';
import ErrorPagePropTypes from './Error.page.props';
import errorPageStyles from './Error.page.styles';

/**
 * ErrorPageComponent
 * @export
 * @class ErrorPageComponent
 * @extends {React.Component<ErrorPageComponentComposedProps, ErrorPageComponentState>}
 */
export class ErrorPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<ErrorPageComponentProps>}
   * @memberof ErrorPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`ErrorPage`}
   * @memberof ErrorPageComponent
   */
  static displayName = `ErrorPage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof ErrorPageComponent
   */
  static propTypes = ErrorPagePropTypes;

  /**
   * Data specific to the `<ErrorPage />` instance
   * @type {ErrorPageComponentState}
   * @memberof ErrorPageComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<ErrorPage />`
   * @memberof ErrorPageComponent
   */
  render() {
    const { classes, entry, status } = this.props;
    return (
      <Page
        className={classes.root}
        heading="ErrorPage.PageHeading"
        headingData={{ name: entry.name, status }}
        hideSidebar
        padding="none"
        title="ErrorPage.PageTitle"
      >
        <Grid container direction="column" wrap="nowrap">
          <Paper className={classes.paper}>
            <I18n className={classes.content} data={{ status }} variant="h5">
              ErrorPage.ErrorMessage
            </I18n>
            <I18n className={cn(classes.content, classes.divider)} variant="body2">
              ErrorPage.SubMessage
            </I18n>
            <I18n className={classes.content} component={Link} to={createHomePageLink()} variant="body2">
              ErrorPage.SubMessageRedirect
            </I18n>
          </Paper>
          <Grid className={classes.footer} item>
            <Footer />
          </Grid>
        </Grid>
      </Page>
    );
  }
}

/** @type {React.ComponentClass<ErrorPageComponentProps>} */
const ErrorPage = compose(
  withStyles(themeCreateInjectableStyles(errorPageStyles), { withTheme: true }),
  withEntries,
)(ErrorPageComponent);

export default ErrorPage;
